<template>
  <div>
    <div class="poll-average mb-2 bold"
      v-if="pollingAverage.margin">
      <span>DDHQ Poll Average: </span>
      <router-link :style="getMarginColor(pollingAverage.margin)" :to="{ name: 'methodology', hash: '#polls' }">
        {{ pollingAverage.margin }}
      </router-link>

    </div>
    <v-data-table
      id="polls-table"
      :class="{mobile: mobile}"
      :headers="pollingHeaders"
      :items="pollingData"
      sort-by="endDate"
      :sort-desc="true"
      mobile-breakpoint="null">
      <template v-slot:item.pollster="{ item }">
        <a :href="item.sourceUrl" target="_blank">{{ item.pollster }}</a>
      </template>
      <template v-slot:item.startDate="{ item }">
        <span>{{ item.startDate }}</span>
      </template>
      <template v-slot:item.endDate="{ item }">
        <span>{{ item.endDate }}</span>
      </template>
      <template v-slot:item.gopPct="{ item }">
        <span>{{ item.gopPct.toFixed(0) }}%</span>
      </template>
      <template v-slot:item.demPct="{ item }">
        <span>{{ item.demPct.toFixed(0) }}%</span>
      </template>
      <template v-slot:item.margin="{ item }">
        <span :style="getMarginColor(item.margin)">{{ item.margin }}</span>
      </template>
      <template v-slot:item.population="{ item }">
        <span>{{ item.population }}</span>
      </template>
      <template v-slot:item.sampleSize="{ item }">
        <span>{{ item.sampleSize | commas }}</span>
      </template>

      <template slot="body.prepend">
        <tr>
          <th>Poll Average</th>
          <th>{{ pollingAverage.startDate }}</th>
          <th>{{ pollingAverage.endDate }}</th>
          <th>{{ pollingAverage.gopPct.toFixed(2) }}%</th>
          <th>{{ pollingAverage.demPct.toFixed(2) }}%</th>
          <th :style="getMarginColor(pollingAverage.margin)">{{ pollingAverage.margin }}</th>
          <th>{{ pollingAverage.population }}</th>
          <th style="text-align: right;">--</th>
        </tr>
      </template>
    </v-data-table>
    <div class="mt-2" style="font-size: 12px;">
      <div>M = margin</div>
      <div>Pop = population</div>
      <div>N = Sample Size</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  electionJson: {
    type: Object,
    required: true
  }
}

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile',
  }),
  pollingAverage () {
    return this.electionJson.pollAverage
  },
  pollingData () {
    return Object.values(this.electionJson.polls)
  }
}

const methods = {
  getMarginColor (value) {
    if (typeof value === 'undefined') {
      return null
    } else if (value.includes('R')) {
      return 'color: var(--gop) !important; text-decoration-color: var(--gop);'
    } else if (value.includes('D')) {
      return 'color: var(--dem) !important; text-decoration-color: var(--dem);'
    } else {
      return 'color: var(--green) !important; text-decoration-color: var(--green);'
    }
  },
}

export default {
  props,
  computed,
  methods,
  data: () => ({
    pollingHeaders: [
      { text: 'Pollster', value: 'pollster', width: '25%' },
      { text: 'Start Date', value: 'startDate', width: '22%' },
      { text: 'End Date', value: 'endDate', width: '22%' },
      { text: 'GOP', value: 'gopPct', width: '12%' },
      { text: 'Dem', value: 'demPct', width: '12%' },
      { text: 'M', value: 'margin', width: '10%' },
      { text: 'Pop', value: 'population', width: '10%' },
      { text: 'N', value: 'sampleSize', width: '10%', align: 'right' }
    ]
  })
}
</script>
